// View states
export const HELM_PRESTART_VIEW = 'HELM_PRESTART_VIEW';
export const HELM_RACE_VIEW = 'HELM_RACE_VIEW';

// How long (in seconds) to show previous boat positions in the watch view
export const WATCH_TAIL_SECONDS = 60;
export const WATCH_UPDATE_FREQUENCY = 10; // Seconds between updates in the watch view

// Pre-start spectator window - how many minutes before race start to enable Live viewing
export const PRESTART_LIVE_WINDOW_MINUTES = 15; // Configurable for spectators to watch pre-start action

// Estimated race duration for when actual end time is not available
export const ESTIMATED_RACE_DURATION_HOURS = 3; // Default estimated race duration in hours

// Watch page time window configuration (for server-side filtering)
export const WATCH_TIME_WINDOW = {
  LOOKBACK_DAYS: 35,       // Show completed races from last 35 days (expanded to catch Sep 25 test data)
  LOOKAHEAD_DAYS: 60,      // Show upcoming races for next 60 days
  RACE_DURATION_HOURS: 3   // Buffer for race duration when calculating completed window
};

export const NAUTICAL_MILE_IN_METERS = 1852;
export const DEFAULT_STARTLINE_SCALE_FACTOR = 1.3;

// Tab labels
export const LABELS = {
  START: 'Start',
  PROFILE: 'Profile', 
  WATCH: 'Watch',
  SAIL: 'Helm',
  COURSE: 'Course',
  WIND: 'Wind',
  PIN: 'Pin', 
  RC: 'RC',
  GUN: 'Gun',
  RESTART: 'Restart'
};

// API endpoints
export const API = {
  RACES: '/api/races',
  EVENTS: '/api/events',
  TRACKING: '/api/tracking'
};

// API Configuration
export const API_CONFIG = {
  DEFAULT_TIMEOUT: 10000, // 10 seconds
  DEFAULT_RETRY_COUNT: 3,
  DEFAULT_RETRY_DELAY: 1000 // 1 second
};

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'fleetly_auth_token',
  USER: 'fleetly_user',
  SELECTED_RACE: 'fleetly_selected_race',
  SELECTED_BOAT: 'fleetly_selected_boat'
};

// Event types
export const EVENT_TYPES = {
  RACE_START: 'RACE_START',
  RACE_END: 'RACE_END',
  WAYPOINT_REACHED: 'WAYPOINT_REACHED'
};

// Race status
export const RACE_STATUS = {
  SCHEDULED: 'scheduled',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

// Course types
export const COURSE_TYPES = {
  T_LEEWARD: 'Leeward',
  T_WINDWARD: 'Windward',
  T_INNER_TRAPEZOID: 'Inner Trapezoid',
  T_OUTER_TRAPEZOID: 'Outer Trapezoid',
  T_TRIANGLE: 'Triangle'
};


  // Finish options for each course type. Key MUST match COURSE_TYPES
  export const FINISH_OPTIONS = {
    ['Leeward']: [
      { label: 'Start finish together', value: 'Start finish together' },
      { label: 'Leeward, Reach port', value: 'Leeward, Reach port' },
      { label: 'Leeward, Reach starboard', value: 'Leeward, Reach starboard' }
    ],
    ['Windward']: [
      { label: 'Windward', value: 'Windward' },
      { label: 'Windward, Reach port', value: 'Windward, Reach port' },
      { label: 'Windward, Reach starboard', value: 'Windward, Reach starboard' }
    ],
    ['Inner Trapezoid']: [
      { label: 'Start finish together. Reach = half beat length', value: 'Start finish together. Reach = half beat length' },
      { label: 'Separate Start finish. Reach = half beat length', value: 'Separate Start finish. Reach = half beat length' },
      { label: 'Equal beats. Reach = half beat length', value: 'Equal beats. Reach = half beat length' },
      { label: 'Reach = 2/3 beat length', value: 'Reach = 2/3 beat length' },
      { label: 'Windward, Equal beats, Reach = 2/3 beat length', value: 'Windward, Equal beats, Reach = 2/3 beat length' },
      { label: 'Windward, Equal beats, Reach = 2/3 beat, Start finish together', value: 'Windward, Equal beats, Reach = 2/3 beat, Start finish together' }
    ],
    ['Outer Trapezoid']: [
      { label: 'Start finish together. Reach = half beat length', value: 'Start finish together. Reach = half beat length' },
      { label: 'Separate Start finish. Reach = half beat length', value: 'Separate Start finish. Reach = half beat length' },
      { label: 'Equal beats. Reach = half beat length', value: 'Equal beats. Reach = half beat length' },
      { label: 'Reach = 2/3 beat length', value: 'Reach = 2/3 beat length' },
      { label: 'Windward, Equal beats, Reach = 2/3 beat length', value: 'Windward, Equal beats, Reach = 2/3 beat length' },
      { label: 'Windward, Equal beats, Reach = 2/3 beat, Start finish together', value: 'Windward, Equal beats, Reach = 2/3 beat, Start finish together' }
    ],
    ['Triangle']: [
      { label: 'Start finish together', value: 'Start finish together' }
    ]
  };


export const MARK_STATUS = {
  DROPPED: 'DROPPED',
  LIFTED: 'LIFTED'
};  

// Mark labels
export const MARKS = {
  S: 'S',    // Start line (between SS and SP)
  F: 'F',    // Finish line (between FP and FS)
  SS: 'SS',
  SP: 'SP',
  SS_FP: 'SS/FP',
  SP_FS: 'SP/FS',
  M1: '1',
  M1P: '1P',
  M1S: '1S',
  M1A: '1A',
  M2: '2',
  M3: '3',
  M3P: '3P',
  M3S: '3S',
  M4: '4',
  M4P: '4P',
  M4S: '4S',
  M5: '5',
  FS: 'FS',
  FP: 'FP'
};

// Base course sequence templates (default port roundings)
export const BASE_COURSE_SEQUENCES = {
  [COURSE_TYPES.T_LEEWARD]: {
    2: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`,
    3: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`,
    4: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`
  },
  [COURSE_TYPES.T_WINDWARD]: {
    2: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`,
    3: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`,
    4: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`
  },
  [COURSE_TYPES.T_INNER_TRAPEZOID]: {
    2: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M2}-${MARKS.M3}-${MARKS.F}`,
    3: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M2}-${MARKS.M3}-${MARKS.F}`,
    4: `${MARKS.S}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M4}-${MARKS.M1}-${MARKS.M2}-${MARKS.M3}-${MARKS.F}`
  },
  [COURSE_TYPES.T_OUTER_TRAPEZOID]: {
    2: `${MARKS.S}-${MARKS.M1}-${MARKS.M2}-${MARKS.M3}-${MARKS.M2}-${MARKS.M3}-${MARKS.F}`,
    3: `${MARKS.S}-${MARKS.M1}-${MARKS.M2}-${MARKS.M3}-${MARKS.M2}-${MARKS.M3}-${MARKS.M2}-${MARKS.M3}-${MARKS.F}`,
    4: `${MARKS.S}-${MARKS.M1}-${MARKS.M2}-${MARKS.M3}-${MARKS.M2}-${MARKS.M3}-${MARKS.M2}-${MARKS.M3}-${MARKS.M2}-${MARKS.M3}-${MARKS.F}`
  },
  [COURSE_TYPES.T_TRIANGLE]: {
    1: `${MARKS.S}-${MARKS.M1}-${MARKS.F}`,
    2: `${MARKS.S}-${MARKS.M1}-${MARKS.M2}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`,
    3: `${MARKS.S}-${MARKS.M1}-${MARKS.M2}-${MARKS.M4}-${MARKS.M1}-${MARKS.M2}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`,
    4: `${MARKS.S}-${MARKS.M1}-${MARKS.M2}-${MARKS.M4}-${MARKS.M1}-${MARKS.M2}-${MARKS.M4}-${MARKS.M1}-${MARKS.M2}-${MARKS.M4}-${MARKS.M1}-${MARKS.F}`
  }
};

// Configuration for sequence modifications based on course options
export const SEQUENCE_MODIFIERS = {
  // Which marks can have gates (gates override individual mark roundings)
  gateableMarks: ['1', '2', '3', '4', '5'],
  
  // Available offset marks
  offsetMarks: {
    '1': '1A',  // Mark 1 offset
    '2': '2A',  // Mark 2 offset  
    '3': '3A'   // Mark 3 offset
  },
  
  // Special rounding rules based on finish type
  finishModifiers: {
    'Leeward, Reach port': {
      insertAfterMark: { afterMark: '1', insertMark: '4P', isLastOccurrence: true }
    },
    'Leeward, Reach starboard': {
      insertAfterMark: { afterMark: '1', insertMark: '4S', isLastOccurrence: true }  
    },
    'Windward': {
      // No special finish modification for windward finish
    },
    'Windward, Reach port': {
      replaceLastMark: { mark: '1', rounding: '1P' }
    },
    'Windward, Reach starboard': {
      replaceLastMark: { mark: '1', rounding: '1S' }
    },
    // Trapezoid windward finishes need Mark 5
    'Windward, Equal beats, Reach = 2/3 beat length': {
      insertBeforeFinish: { insertMark: '5' }
    },
    'Windward, Equal beats, Reach = 2/3 beat, Start finish together': {
      insertBeforeFinish: { insertMark: '5' }
    }
  },
  
  // Rules for offset mark constraints
  offsetRules: {
    // If offset mark exists, the main mark cannot be a gate
    offsetNegatesGate: true,
    // Reaching finishes require offset marks
    reachingFinishRequiresOffset: true
  }
};

/**
 * Generate course sequence definition from configuration
 * 
 * @param {string} courseType - Course type from COURSE_TYPES
 * @param {number} windwardBeats - Number of windward beats (2-4)
 * @param {boolean} gate1 - Is mark 1 a gate?
 * @param {boolean} gate3 - Is mark 3 a gate?
 * @param {boolean} gate4 - Is mark 4 a gate?
 * @returns {string} Sequence definition (e.g., "S-1-4G-1-F")
 * 
 * Note: For complete sequence generation with finish types and offsets,
 * use generateSequenceString() from courseSequence.js
 */
export const generateCourseSequence = (courseType, windwardBeats, gate1 = false, gate3 = false, gate4 = false) => {
  // Get base sequence from lookup table
  const baseSequence = BASE_COURSE_SEQUENCES[courseType]?.[windwardBeats];
  if (!baseSequence) {
    console.warn(`No base sequence found for ${courseType} with ${windwardBeats} beats`);
    return '';
  }
  
  let sequence = baseSequence;
  
  // Apply gate modifiers
  // Important: Use word boundaries to avoid replacing '1' in '10' or '11'
  if (gate1) {
    // Replace '-1-' with '-1G-' and '-1$' with '-1G' (end of sequence)
    sequence = sequence.replace(/-1-/g, '-1G-').replace(/-1$/g, '-1G');
  }
  if (gate3) {
    sequence = sequence.replace(/-3-/g, '-3G-').replace(/-3$/g, '-3G');
  }
  if (gate4) {
    sequence = sequence.replace(/-4-/g, '-4G-').replace(/-4$/g, '-4G');
  }
  
  return sequence;
};


